module.exports = __webpack_public_path__ + "static/media/y_v.694d931.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/img/y_v.mp4
// module id = 29x3
// module chunks = 1